import { useMutation } from "urql";

import { ImportInvoiceDocument } from "../../../graphql/generated.ts";

export function useImportInvoice() {
  return useMutation(ImportInvoiceDocument);
}
